var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationIcon = function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 18v.5a.5.5 0 0 0 .38-.825zM5 18l-.434-.248A.5.5 0 0 0 5 18.5zm14-.5H5v1h14zM17.5 10v1h1v-.999zm0 1c0 2.943.252 4.735.514 5.806.132.537.267.897.377 1.132a2.4 2.4 0 0 0 .195.344l.02.025.007.01.004.005.002.002c.001 0 .001.001.381-.324l.38-.325.001.001.002.002.002.003.007.008q0 0-.012-.017a2 2 0 0 1-.083-.157 5 5 0 0 1-.311-.946c-.238-.97-.486-2.678-.486-5.569zM5 18l.434.247.002-.001.001-.004.018-.032.04-.083q.05-.104.128-.304c.103-.27.235-.675.364-1.243.26-1.136.513-2.924.513-5.58h-1c0 2.594-.247 4.306-.487 5.357-.12.526-.239.887-.324 1.11a3 3 0 0 1-.125.289v-.002l.001-.001zm1.5-7v-.998h-1V11zM12 4.5a5.5 5.5 0 0 1 5.5 5.5h1A6.5 6.5 0 0 0 12 3.5zm0-1c-3.59 0-6.5 2.912-6.5 6.502h1A5.5 5.5 0 0 1 12 4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.421 19.877a.5.5 0 0 1 .5.5c0 .082.05.216.253.352.2.134.504.234.866.234.36 0 .665-.1.865-.234.203-.136.253-.27.253-.352a.5.5 0 1 1 1 0c0 .517-.313.926-.696 1.183-.386.259-.89.403-1.422.403-.533 0-1.037-.144-1.423-.403-.383-.257-.696-.666-.696-1.183a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 2a.5.5 0 0 1 .5.5v1.3a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 12 2",
    clipRule: "evenodd"
  })));
};
export default SvgNotificationIcon;